// Globals
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Models
import { OrderCancellationReason } from '@/models/orders.model';

// Components
import { StyledTitleModal, StyledSubTitleModal, StyledButton } from './CancelOrderModalStyles';
import { Modal, ModalSize } from '@/components';
import CancellationReasonFields from '../CancellationReasonFields/CancellationReasonFields';

interface CancelOrderModalProps {
  isOpenCancelOrderModal: boolean;
  isLoading: boolean;
  closeCancelOrderModal: () => void;
  handleCancelOrder: (reason: OrderCancellationReason, reasonText?: string) => void;
}

const CancelOrderModal = ({
  isOpenCancelOrderModal,
  isLoading,
  closeCancelOrderModal,
  handleCancelOrder,
}: CancelOrderModalProps) => {
  const { t } = useTranslation(['orders']);
  const [reason, setReason] = useState<OrderCancellationReason | undefined>();
  const [reasonText, setReasonText] = useState('');

  useEffect(() => {
    if (isOpenCancelOrderModal) {
      setReason(undefined);
      setReasonText('');
    }
  }, [isOpenCancelOrderModal]);

  const isOtherWithoutText = reason === OrderCancellationReason.OTHER && !reasonText.trim();
  const isConfirmDisabled = isLoading || !reason || isOtherWithoutText;

  const onConfirm = () => {
    if (!reason || isOtherWithoutText) {
      return;
    }

    handleCancelOrder(reason, reason === OrderCancellationReason.OTHER ? reasonText.trim() : undefined);
  };

  return (
    <Modal visible={isOpenCancelOrderModal} onCancel={closeCancelOrderModal} size={ModalSize.LARGE}>
      <StyledTitleModal>{t('cancel_order_modal_title')}</StyledTitleModal>
      <StyledSubTitleModal>{t('cancel_order_modal_sub_title')}</StyledSubTitleModal>
      <CancellationReasonFields
        reason={reason}
        reasonText={reasonText}
        onReasonChange={setReason}
        onReasonTextChange={setReasonText}
      />
      <StyledButton onClick={onConfirm} disabled={isConfirmDisabled} type="primary">
        {t('cancel_order_modal_button')}
      </StyledButton>
    </Modal>
  );
};

export default CancelOrderModal;
